<button appTooltip="Move Feature" class="esk-tool" [ngClass]="{'esk-tool--active' : active()===true}" (click)="toggleTool()" ><i class="fa fa-arrows"></i></button>
